module.exports = __webpack_public_path__ + "static/media/icon_upload.ebc46cba.svg";